import React from 'react';
import Logo from "../../Components/Logo";
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Header from "../../Layouts/Header";
import {TbArrowBadgeLeft} from "react-icons/tb";
import Loading from "../../Layouts/Loading";


export default function Register() {

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [buttonStatus, setButtonStatus] = React.useState( "");
    const [buttonText, setButtonText] = React.useState('ادامه');
    const [loading, setLoading] = React.useState('d-none');
    const [surname, setSurname] = React.useState("");
    const [name, setName] = React.useState("");
    const [groups, setGroups] = React.useState([]);
    const [groupId, setGroupId] = React.useState(0);
    const [states, setStates] = React.useState([]);
    const [stateId, setStateId] = React.useState(0);
    const [cities, setCities] = React.useState([]);
    const [cityID, setCityId] = React.useState(0);
    const [areas, setAreas] = React.useState([]);
    const [areaId, setAreaId] = React.useState(0);

    React.useEffect(() => {
        API.getUserGroups()
            .then((response) => {
                setGroups(response.data);

                API.getStates()
                    .then((response) => {
                        setStates(response.data);
                        setIsLoaded(true)

                    })
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });
    }, []);


    const onGetCities = (stateID) => {
        setIsLoaded(false)
        const params = {
            state_id : stateID
        }
        API.getCities(params)
            .then((response) => {
                setCities(response.data);
                setIsLoaded(true)

            })
    }

    const onGetAreas = (stateID) => {
        setIsLoaded(false)
        const params = {
            city_id : stateID
        }
        API.getAreas(params)
            .then((response) => {
                setAreas(response.data);
                setIsLoaded(true)

            })
    }
    const onNameChange = (event) => {
        setName(event.target.value)
    }
    const onSurNameChange = (event) => {
        setSurname(event.target.value)
    }

    const onButtonClick =  () => {


        if(groupId < 1) {
            toast.error('لطفا صنف خود را مشخص کنید');
            return false;
        }

        if(areaId < 1) {
            toast.error('لطفا منطقه شهری خود را مشخص کنید');
            return false;
        }
        setButtonText("");
        setLoading("d-inline-block");
        setButtonStatus("disabled");

        const formData = new FormData();

        formData.append('surname', surname);
        formData.append('name', name);
        formData.append('user_group_id', groupId);
        formData.append('province_id', stateId);
        formData.append('city_id', cityID);
        formData.append('area_id', areaId);
        formData.append('device_info', navigator.userAgent);

        API.updateProfile( formData )
            .then((response) => {
                toast.success(response.message);
                window.localStorage.removeItem("needRegistration");

                setTimeout (() => {
                    let cartItems = JSON.parse(window.localStorage.getItem("cart"));
                   cartItems ? window.location.replace('/cart') : window.location.replace('/home');
                },1500)

            })
            .catch((error) => {
                toast.error(error.response.data.message)
                setButtonText("ادامه");
                setLoading("d-none")
                setButtonStatus('')

            });
    }


    return (
        <React.Fragment>
            <Header title='  ثبت نام' hasBack={true}/>
            <Toast />
            {
                !isLoaded && <Loading />
            }
            <section className="container-fluid rtl mt-3">
                <div className="row">
                    <div className="col-12">
                        <Logo size={110} />
                    </div>
                    <div className="col-12 mt-4 text-end text-black fw-bold pe-4 mb-3  ">
                       ثبت نام

                    </div>
                    <div className="col-12 my-2 text-end text-small-2 text-muted pe-4  ">
                        به نظر می رسد تا کنون از اپلیکیشن ما استفاده نکرده اید :)
                        <br/>
                        لطفا برای ادامه کار نام خانوادگی خود را وارد کنید

                    </div>

                    <div className="col-12 mt-3 ">
                        <div className="form-floating mb-3">
                            <input type="text"
                                   className="form-control text-center text-big-2"
                                   id="floatingInput"
                                   placeholder="otp"
                                   value={name}
                                   onChange={onNameChange}
                            />
                            <label htmlFor="floatingInput" className="right-0">
                              نام
                            </label>
                        </div>
                    </div>

                    <div className="col-12 mt-3 ">
                        <div className="form-floating mb-3">
                            <input type="text"
                                   className="form-control text-center text-big-2"
                                   id="floatingInput"
                                   placeholder="otp"
                                   value={surname}
                                   onChange={onSurNameChange}
                            />
                            <label htmlFor="floatingInput" className="right-0">
                              نام خانوادگی
                            </label>
                        </div>
                    </div>

                    <div className="col-12 mt-3 ">
                        <div className="form-floating">
                            <select className="form-select" id="floatingSelect"
                                    aria-label="Floating label select example"
                            onChange={(event) => {
                                setGroupId(event.target.value)
                            }}

                            >
                                <option selected>انتخاب صنف</option>
                                {
                                    isLoaded && groups.map(group => {
                                            return (
                                                <option value={group.id} key={group.id}>
                                                    {group.name}
                                                </option>
                                            );
                                        }
                                    )
                                }

                            </select>
                            <label htmlFor="floatingSelect" className="right-0">

                            </label>
                        </div>
                    </div>


                    <div className="col-12 mt-4 border-top pt-3 ">
                        <div className="form-floating">
                            <select className="form-select" id="floatingSelect"
                                    aria-label="Floating label select example"
                            onChange={(event) => {
                                setStateId(event.target.value)
                                onGetCities(event.target.value)
                            }}
                                    value={stateId}

                            >
                                <option selected value={0}>انتخاب استان</option>
                                {
                                    isLoaded && states.map(group => {
                                            return (
                                                <option value={group.id} key={group.id}>
                                                    {group.name}
                                                </option>
                                            );
                                        }
                                    )
                                }

                            </select>
                            <label htmlFor="floatingSelect" className="right-0">

                            </label>
                        </div>
                    </div>



                    <div className="col-12 mt-3 ">
                        <div className="form-floating">
                            <select className="form-select" id="floatingSelect"
                                    aria-label="Floating label select example"
                            onChange={(event) => {
                                setCityId(event.target.value)
                                onGetAreas(event.target.value)
                            }}
                                    value={cityID}

                            >
                                <option selected  value={0}>انتخاب شهر</option>
                                {
                                    isLoaded && cities.map(group => {
                                            return (
                                                <option value={group.id} key={group.id}>
                                                    {group.name}
                                                </option>
                                            );
                                        }
                                    )
                                }

                            </select>
                            <label htmlFor="floatingSelect" className="right-0">

                            </label>
                        </div>
                    </div>


                    <div className="col-12 mt-3 mb-5 pb-5 ">
                        <div className="form-floating">
                            <select className="form-select" id="floatingSelect"
                                    aria-label="Floating label select example"
                            onChange={(event) => {
                                setAreaId(event.target.value)

                            }}
value={areaId}
                            >
                                <option selected  value={0}>انتخاب منطقه شهری</option>
                                {
                                    isLoaded && areas.map(group => {
                                            return (
                                                <option value={group.id} key={group.id}>
                                                    {group.name}
                                                </option>
                                            );
                                        }
                                    )
                                }

                            </select>
                            <label htmlFor="floatingSelect" className="right-0">

                            </label>
                        </div>
                    </div>




                </div>

                <div className="row">
                    <div className="col-12 p-2 fixed-bottom max-w-lg">

                        <button
                            className="btn btn-success bg-secondary-color text-center text-small-1 text-semi-big  w-100 p-2  pr-4 border-0"
                            onClick={onButtonClick}
                            disabled={buttonStatus}
                        >
                            {buttonText}
                            <span className="badge  p-2 float-start">
<TbArrowBadgeLeft className='text-big-3' />
                    </span>
                            <span  className={"spinner-grow spinner-grow-sm " + loading} role="status"
                                   aria-hidden="true">

                            </span>
                        </button>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}
